import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i5 from '@angular/material/badge';
import { MatBadgeModule } from '@angular/material/badge';
import * as i4 from '@xpo-ltl/ngx-ltl-core/badge';
import { XpoBadgeModule } from '@xpo-ltl/ngx-ltl-core/badge';
import * as i1 from '@xpo-ltl/ngx-ltl-core/xpo-ltl-popover';
import { XpoLtlPopoverModule } from '@xpo-ltl/ngx-ltl-core/xpo-ltl-popover';

function XpoNotificationPopover_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1, "notifications");
    i0.ɵɵelementEnd();
} }
function XpoNotificationPopover_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 8);
    i0.ɵɵtext(1, " notifications");
    i0.ɵɵelementEnd();
} }
function XpoNotificationPopover_a_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵproperty("href", item_r4.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r4.title);
} }
class XpoNotificationPopover {
}
XpoNotificationPopover.ɵfac = function XpoNotificationPopover_Factory(t) { return new (t || XpoNotificationPopover)(); };
XpoNotificationPopover.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoNotificationPopover, selectors: [["xpo-notification-popover"]], hostAttrs: [1, "xpo-NotificationPopover"], inputs: { notifications: "notifications", caretPosition: "caretPosition", position: "position" }, decls: 11, vars: 6, consts: [[1, "xpo-NotificationPopover-trigger", 3, "xpoLtlpopoverTriggerFor"], [4, "ngIf"], ["xpoBadgeDotImportant", "", "matBadge", "", 4, "ngIf"], ["color", "accent", "hideCloseButton", "true", 3, "caretPosition", "position"], ["popover", "xpoLtlPopover"], [1, "xpo-NotificationPopover-title"], [1, "xpo-NotificationPopover-listContainer"], ["class", "xpo-NotificationPopover-item", 3, "href", 4, "ngFor", "ngForOf"], ["xpoBadgeDotImportant", "", "matBadge", ""], [1, "xpo-NotificationPopover-item", 3, "href"]], template: function XpoNotificationPopover_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, XpoNotificationPopover_mat_icon_1_Template, 2, 0, "mat-icon", 1);
        i0.ɵɵtemplate(2, XpoNotificationPopover_mat_icon_2_Template, 2, 0, "mat-icon", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "xpo-ltl-popover", 3, 4);
        i0.ɵɵelementStart(5, "xpo-ltl-popover-header");
        i0.ɵɵelementStart(6, "span", 5);
        i0.ɵɵtext(7, "Notifications");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "xpo-ltl-popover-content");
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtemplate(10, XpoNotificationPopover_a_10_Template, 3, 2, "a", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = i0.ɵɵreference(4);
        i0.ɵɵproperty("xpoLtlpopoverTriggerFor", _r2);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !(ctx.notifications == null ? null : ctx.notifications.length));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.notifications == null ? null : ctx.notifications.length);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("caretPosition", ctx.caretPosition ? ctx.caretPosition : "end")("position", ctx.position ? ctx.position : "below");
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("ngForOf", ctx.notifications);
    } }, directives: [i1.XpoLtlPopoverTrigger, i2.NgIf, i1.XpoLtlPopover, i1.XpoLtlPopoverHeader, i1.XpoLtlPopoverContent, i2.NgForOf, i3.MatIcon, i4.XpoBadgeDotImportant, i5.MatBadge], styles: [".flex--stretch{flex:1}.xpo-NotificationPopover{cursor:pointer}.xpo-NotificationPopover-trigger{display:flex;height:30px;justify-content:center;width:40px}.xpo-NotificationPopover .mat-icon{color:#4a4a4a;display:flex}.xpo-NotificationPopover .mat-badge-medium.xpo-BadgeDot.mat-badge-overlap.mat-badge-after .mat-badge-content{height:6px;right:-4px;top:5px;width:6px}.xpo-NotificationPopover-listContainer{min-width:300px}.xpo-NotificationPopover-item{align-items:center;color:#4a4a4a;display:flex;font-weight:500;height:3rem;padding:0 8px;width:100%}.xpo-NotificationPopover-item:hover,.xpo-NotificationPopover-item:focus{background-color:#f3f3f3;color:#4a4a4a;text-decoration:none}.xpo-NotificationPopover-title{font-size:1.143rem;font-weight:500;line-height:1.143rem}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoNotificationPopover, [{
        type: Component,
        args: [{
                selector: 'xpo-notification-popover',
                templateUrl: './notification-popover.html',
                styleUrls: ['./notification-popover.scss'],
                host: {
                    class: 'xpo-NotificationPopover',
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
            }]
    }], null, { notifications: [{
            type: Input
        }], caretPosition: [{
            type: Input
        }], position: [{
            type: Input
        }] }); })();

class XpoNotificationPopoverModule {
}
XpoNotificationPopoverModule.ɵfac = function XpoNotificationPopoverModule_Factory(t) { return new (t || XpoNotificationPopoverModule)(); };
XpoNotificationPopoverModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoNotificationPopoverModule });
XpoNotificationPopoverModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, XpoLtlPopoverModule, MatButtonModule, XpoBadgeModule, MatBadgeModule, MatIconModule], XpoBadgeModule, MatBadgeModule, MatIconModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoNotificationPopoverModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, XpoLtlPopoverModule, MatButtonModule, XpoBadgeModule, MatBadgeModule, MatIconModule],
                declarations: [XpoNotificationPopover],
                exports: [XpoNotificationPopover, XpoBadgeModule, MatBadgeModule, MatIconModule],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoNotificationPopoverModule, { declarations: [XpoNotificationPopover], imports: [CommonModule, XpoLtlPopoverModule, MatButtonModule, XpoBadgeModule, MatBadgeModule, MatIconModule], exports: [XpoNotificationPopover, XpoBadgeModule, MatBadgeModule, MatIconModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoNotificationPopover, XpoNotificationPopoverModule };
